<template>
  <div class="phone-number-with-type">
    {{ phoneNumber.number }}
    <span v-if="phoneNumber.type">({{ phoneNumber.type }})</span>
  </div>
</template>

<script>
import { Phone } from "../models/Phone";

export default {
  name: "PhoneNumberWithType",
  props: {
    phoneNumber: {
      type: Phone,
      required: true
    }
  }
};
</script>

<style scoped></style>
